import { useState } from "react";
import FleetStatusCards from "./fleet-status-cards.jsx";
import FleetTable from "./fleet-table.jsx";
import { useFilters } from "@/hooks/useFilters.js";
import FilterDrawer from "./filter-drawer.jsx";
import { cardStyles } from "@/lib/status-styles.js";

/**
 * Fleet Overview component that displays fleet status cards and filtering interface
 * @returns {JSX.Element} Fleet overview with filters and data display
 */
export default function FleetOverview() {
  // Use the custom filters hook
  const { filters, handleFilterChange, handleStatusClick, clearFilters } =
    useFilters();

  // Hoist search state to this level to share between FleetStatusCards and FleetTable in order for
  // the filter counts to have access to it.
  // This could be a context later on if needed but for now this is something simple that works.
  const [search, setSearch] = useState("");

  return (
    <div className='flex flex-col flex-1 min-h-full gap-6'>
      {/* Status Cards */}
      <div className='shrink-0'>
        <FleetStatusCards
          onStatusClick={handleStatusClick}
          activeFilters={filters.status}
          filters={filters}
          searchTerm={search}
        />
      </div>

      {/* Filters */}
      <div className='shrink-0'>
        <FilterDrawer
          filters={filters}
          onFilterChange={handleFilterChange}
          onClearFilters={clearFilters}
          onStatusClick={handleStatusClick}
          searchTerm={search}
        />
      </div>

      {/* Fleet Table — fills remaining height with a scrollable floor */}
      <div className={cardStyles.tableFillRegion}>
        <FleetTable
          filters={filters}
          search={search}
          onSearchChange={setSearch}
        />
      </div>
      <div className={cardStyles.pageBottomSpacer} aria-hidden='true' />
    </div>
  );
}
